<template>
  <div class="content">
    <div class="title">
      <!-- <img src="../../../../assets/icon/title_01.png" alt="" /> -->
      <div class="test">
        {{ title }}
      </div>
      <!-- <img src="../../../../assets/icon/title_02.png" alt="" /> -->
    </div>
    <img @click="showIgm" :src="url" alt="" />
    <div class="abstract">
      <span>简介</span>
    </div>
    <div class="remark" v-html="remark ? remark : '暂无'"></div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";
export default {
  data() {
    return {};
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
  },
  methods: {
    showIgm() {
      ImagePreview([this.url]);
    },
  },
};
</script>

<style scoped lang='scss'>
div {
  box-sizing: border-box;
}
.content {
  display: flex;
  flex-direction: column;
  width: 100%;
  img {
    width: 100%;
  }
  .title {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    font-size: 18px;
    font-weight: 600;
    color: #333;
    padding: 10px 14px;
    .test {
      padding: 12px 6px;
      text-align: center;
    }
    img {
      width: 20px;
    }
  }
  .abstract {
    padding: 20px 14px 8px 14px;
    span {
      padding: 8px 8px;
      font-size: 18px;
      font-weight: 600;
      color: #333;
      background: linear-gradient(
        to top,
        rgb(212, 234, 248) 0%,
        rgb(212, 234, 248) 50%,
        white 51%,
        white 100%
      );
    }
  }
  .remark {
    padding: 10px 18px;
    width: 100%;
    font-size: 14px;
    color: #666;
  }
}
</style>